import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { setPassword } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";
import { useTranslation } from 'react-i18next';
import ScrollLockModal from "Component/Common/ScrollLock-Model";
import ErrorMessage from "Component/Common/ErrorMessage";
import { error } from "toastr";

export default function SetPasswordModel(props) {
    const [errorText, setErrorText] = useState();
  /**
     * Used for initialise the states on first render
     */
    const [fields, setFields] = useState({
        newPassword: "",
        confirm_password: ""
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user, loading } = useSelector(({ Login }) => Login);
    const [passwordTypeNew, setNewPasswordType] = useState("password");
    const [passwordTypeConfirm, setConfirmPasswordType] = useState("password");

    const { t } = useTranslation();

    const toastr = useToastr();


    const toggleNewPassword = () => {
        if (passwordTypeNew === "password") {
            setNewPasswordType("text");
            return;
        }
        setNewPasswordType("password");
    };

    const toggleConfirmPassword = () => {
        if (passwordTypeConfirm === "password") {
            setConfirmPasswordType("text");
            return;
        }
        setConfirmPasswordType("password");
    };


      /**
     * Used for submit the password to the backend
     */
    const handleSubmit = () => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}[\]:;<>,.?~\\-])(?=.{8,})/;

        if (fields.confirm_password == "" ||
            fields.newPassword == "") {
            //  toastr.error(t('all_fields_required'))
            setErrorText(t('all_fields_required'))
            return;
        }

        const isValidPassword = passwordRegex.test(fields.newPassword);
        if (!isValidPassword) {
            // return toastr.error(t('password_error'))
            setErrorText(t('password_error'))
            return;
        }


        if (fields.newPassword !== fields.confirm_password) {
            // return toastr.error(t('password_not_match'));
            setErrorText(t('password_not_match'))
            return;

        }


        const callback = (response) => {
            if (response.status == "success") {
                toastr.success(t('password_changed'));
                hidePopup()
                setFields((prev) => ({
                    ...prev,
                    confirm_password: "",
                    newPassword: "",
                }));

            } else {
                setErrorText(response.message)
                return;
            }
        }


        const info = {
            password: fields?.newPassword,
        }

        dispatch(setPassword(info, callback));
    }


    const handleChange = (name) => (e) => {
        setFields(prev => ({ ...prev, [name]: e.target.value }))
    }


    const handleKeyDown = (e) => {
        if (e.keyCode === 32) {
            e.preventDefault();
        }
    }


    const hidePopup = () => {
        setErrorText("");
        setFields({
            ...fields,
            newPassword: "",
            confirm_password: ""
        })
        props.onHide();
    }


  /**
     * Used for render the UI for set password if user logged in using google or apple
     */
    return (
        <>

            <ScrollLockModal {...props} >
                {loading && <Loader />}

                <div className="modal_inner_main position-relative">
                    <a
                        href="javascript:void(0)"
                        onClick={() => {
                            hidePopup()
                            setFields((prev) => ({
                                ...prev,
                                newPassword: "",
                                confirm_password: ""
                            }));
                        }}
                        className="close-btn"
                    >
                        <img src="/images/close_img.png" alt="" className="img-fluid" />
                    </a>


                    <div className="modal_buy-cont">

                        <h5 className="mb-4">{t('set_password')}</h5>



                        <Row >
                         
                            <Col lg={12} sm={12}>
                                <FormGroup className="position-relative">
                                    <Label for="examplePassword">{t('new_password')} <span className="col_red"><sup>*</sup></span></Label>
                                    <Input
                                        type={passwordTypeNew}
                                        name="newPassword"
                                        id="newPassword"
                                        onChange={handleChange("newPassword")}
                                        onKeyDown={handleKeyDown}
                                        title={t('fill_this_field')}


                                    />
                                    {passwordTypeNew === "password" ?
                                        <Button className="eye_btn" onClick={toggleNewPassword}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z" /></svg>

                                        </Button> :
                                        <Button className="eye_btn" onClick={toggleNewPassword}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25"
                                                height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34" /></svg>
                                        </Button>
                                    }
                                </FormGroup>

                            </Col>
                            <Col lg={12} sm={12}>
                                <FormGroup className="position-relative">
                                    <Label for="examplePassword">{t('confirm_password')} <span className="col_red"><sup>*</sup></span></Label>
                                    <Input
                                        type={passwordTypeConfirm}
                                        name="confirm_password"
                                        id="confirm_password"
                                        onChange={handleChange("confirm_password")}
                                        onKeyDown={handleKeyDown}
                                        title={t('fill_this_field')}


                                    />
                                    {passwordTypeConfirm === "password" ?
                                        <Button className="eye_btn" onClick={toggleConfirmPassword}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z" /></svg>

                                        </Button> :
                                        <Button className="eye_btn" onClick={toggleConfirmPassword}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25"
                                                height="25" viewBox="0 0 256 256"><path fill="#9BA1B3" d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34" /></svg>
                                        </Button>
                                    }
                                </FormGroup>

                            </Col>

                        </Row>

                        <div className="modal_buy_btn d-flex justify-content-center gap-3">
                            <Button
                                className="mod_cancelbtn clomod_btn"
                                onClick={() => {
                                    hidePopup()

                                }}
                            >
                                {t('close')}
                            </Button>

                            <Button className="mod_confirmbtn copy_btn" onClick={handleSubmit} type="submit">
                                {t('submit')}
                            </Button>

                        </div>


                        {
                            errorText &&
                            <ErrorMessage errorText={errorText} />
                        }

                    </div>
                </div>


            </ScrollLockModal >
        </>

    );
}
